import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsService } from './app-settings.service';
import {
  AppConfigurationResponse,
  UpdateAppConfigurationPayload,
  UpdateConsultantNotificationRuleTemplatePayload,
} from '../../shared/models/app-configuration';

@Injectable({
  providedIn: 'root',
})
export class AppConfigurationService extends AppSettingsService {
  constructor(private readonly http: HttpClient) {
    super();
  }

  getConfiguration() {
    return this.http.get<AppConfigurationResponse>(`${this.apiUrl}/api/app-configuration`);
  }

  updateConfiguration(payload: UpdateAppConfigurationPayload) {
    return this.http.put<void>(`${this.apiUrl}/api/app-configuration`, payload);
  }

  updateNotificationTemplate(payload: UpdateConsultantNotificationRuleTemplatePayload) {
    return this.http.put<void>(`${this.apiUrl}/api/app-configuration/notification-rules/template`, payload);
  }
}
